import { chalk, error, box } from "./chalk";
import { cleanEnv, makeValidator } from "envalid";
const reporter = ({ errors }) => {
    if (!errors || Object.keys(errors).length < 1)
        return;
    chalk(error, "Fatal misconfiguration in environment", console.error);
    chalk(box, Object.entries(errors)
        .map(([key, error]) => `${key}: ${(error === null || error === void 0 ? void 0 : error.message) === "undefined" ? "Missing environment variable" : error === null || error === void 0 ? void 0 : error.message}`)
        .join("\n"));
    alert("Fatal misconfiguration in environment! Please contact administrator.");
    throw new Error("Fatal misconfiguration in environment");
};
const TRUE_VALS = ["yes", "y", "true", "t", "1"];
const FALSE_VALS = ["no", "n", "false", "f", "0"];
export const yesNo = makeValidator(x => {
    const input = `${x}`;
    if (TRUE_VALS.includes(input))
        return true;
    if (FALSE_VALS.includes(input))
        return false;
    throw new Error(`Input "${input}" invalid. Expected value of ${TRUE_VALS.join(" | ")} or ${FALSE_VALS.join(" | ")}`);
});
export const requiredStr = makeValidator(x => {
    if (typeof x === "string" && x.length > 0)
        return `${x}`;
    throw new Error(`Input "${x}" invalid. Expected non empty string value`);
});
export const fromWeb = (schema) => {
    return cleanEnv(Object.assign(Object.assign({}, process.env), window.env), schema, { reporter });
};
